import React from 'react';

export const PartidosDefinicion = {
  UNICO: 1,
  IDA_Y_VUELTA: 2,
};

const CampoOptionsPartidosDefinicion = (props) => {
  const estilo = props.estilo;
  const editar = props.editar;
  const nombre = props.nombre;
  const valor = props.valor;

  const onChangeHandler = (event) => {
    const numValue = parseInt(event.target.value, 10);
    props.onChange(nombre, numValue);
  };

  let campo = '';
  if (editar) {
    campo = (
      <div className={`${estilo}`}>
        <label>
          <input
            type="radio"
            name="partidosDefinicion"
            value="1"
            checked={valor === 1}
            onChange={onChangeHandler}
          />{' '}
          Único
        </label>
        {'  '}
        <label>
          <input
            type="radio"
            name="partidosDefinicion"
            value="2"
            checked={valor === 2}
            onChange={onChangeHandler}
          />{' '}
          Ida y vuelta
        </label>
      </div>
    );
  } else {
    campo = valor === 1 ? 'Único' : valor === 2 ? 'Ida y vuelta' : '';
  }

  return <React.Fragment>{campo}</React.Fragment>;
};

export default CampoOptionsPartidosDefinicion;
